module.exports = "../../../../platform/assets/pageMainIcon/jichudanganlei4.svg";